/* eslint-disable react/jsx-no-target-blank */
//import { KTIcon } from "../../../helpers";

const SidebarFooter = () => {
	return (
		<div className='app-sidebar-footer   px-6' id='kt_app_sidebar_footer' style={{height: '20px'}}>
		 {/* <a
				href={process.env.REACT_APP_PREVIEW_DOCS_URL}
				target='_blank'
				className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
				data-bs-toggle='tooltip'
				data-bs-trigger='hover'
				data-bs-dismiss-='click'
				title='Metronic Docs & Components'>
				<span className='btn-label'>Docs & Components</span>
				<KTIcon iconName='document' className='btn-icon fs-2 m-0' />
			</a>  */}
			<span style={{color:"#fff", paddingLeft:"20px"}}>Version: 2.3</span>
		</div>
	);
};

export { SidebarFooter };
